import { render } from "./bgicon.vue?vue&type=template&id=98292a60"
import script from "./bgicon.vue?vue&type=script&lang=js"
export * from "./bgicon.vue?vue&type=script&lang=js"

import "./bgicon.vue?vue&type=style&index=0&id=98292a60&lang=scss"

import exportComponent from "C:\\Project\\DeepLink\\OrionRaceWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__